module.exports = __webpack_public_path__ + "img/check-green.84016d57.svg";